module.exports = __webpack_public_path__ + "static/media/77.922c83a4.png";